var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
/** Título de seção da página de Atualizações (ex.: "Textos", "Imagens"). */
function SectionTitle(_a) {
    var children = _a.children;
    return _jsx("h3", __assign({ className: "settings-section-title" }, { children: children }));
}
export default SectionTitle;
